import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../config/constants';
import { useEffect } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { OrganisationService } from '../services/organisation/organizationService';
import { setSelectedOrganisation } from '../store/slices/organizationSlice';
import { useDispatch } from 'react-redux';
import { setSelectedOrganizationId } from '../store/slices/organizationContextSlice';

interface CustomerViewProps {
  clientId: string | null;
}

const CustomerView = ({ clientId }: CustomerViewProps) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (clientId) {
      const loadOrganization = async () => {
        try {
          const results = await OrganisationService.getClientOrganisation(clientId);
          const selectedOrganisation = results[0];
          console.log('selectedOrganisation customer view', selectedOrganisation);
          if (!selectedOrganisation) {
            throw new Error('No organization found');
          }

          dispatch(setSelectedOrganisation(selectedOrganisation));
          dispatch(setSelectedOrganizationId(selectedOrganisation.id));

          if (!selectedOrganisation.subscriptionEndDate) {
            navigate(ROUTES.SUBSCRIPTIONS);
            return;
          }

          const currentDate = new Date();
          const subscriptionEndDate = new Date(selectedOrganisation.subscriptionEndDate);
          console.log(currentDate, subscriptionEndDate);

          if (currentDate > subscriptionEndDate) {
            navigate(ROUTES.SUBSCRIPTIONS);
            return;
          }

          navigate(ROUTES.DASHBOARD);
        } catch (error) {
          throw error;
        }
      };

      loadOrganization();
    }
  }, [clientId, navigate]);

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
      <CircularProgress size={24} />
    </Box>
  );
};

export default CustomerView;
